import React from "react";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  FormFeedback,
} from "reactstrap";
import Page from "components/Page";
import axios from "axios";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";
import { ReactTitle } from "react-meta-tags";
import { Link } from "react-router-dom";
import AppConstants from "AppConstants";
import placeholderimg from "./../assets/img/placeholder.png";
import { MdInfoOutline } from "react-icons/md";

class ViewadminProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: this.props.auth.user._id,
      firstname: "",
      lastname: "",
      email: "",
      profile_img: "",
      address1: "",
      phone: "",
      gender: "",
      errMsg: "",
      address2: "",
      country: "",
      state: "",
      zipcode: "",
      city: "",
    };
    this.inputChangedHandlerContact = this.inputChangedHandlerContact.bind(
      this
    );
  }
  inputChangedHandlerContact = (values) => {
    this.setState({
      phone: values.value,
    });
  };
  componentDidMount() {
    console.log("this.props.auth.user._id", this.props);
    const that = this;
    fetch(AppConstants.API + "/users/profile/" + that.props.auth.user._id)
      .then(function (res) {
        if (res.status == 200) {
          return res.json();
        }
      })
      .then(function (data) {
        console.log(data);
        if (data.Status == "Success") {
          that.setState({
            firstname: data.data.firstname,
            lastname: data.data.lastname,
            email: data.data.email,
            profile_image: data.data.profile_image,
            address1: data.data.address1,
            phone: data.data.phone,
            gender: data.data.gender,
            country: data.data.country,
            state: data.data.state,
            address2: data.data.address2,
            city: data.data.city,
            zipcode: data.data.zipcode,
          });
        } else {
        }
      });
  }

  render() {
    const { user } = this.props.auth;
    const { phone } = this.state;
    let image;
    if (this.state.profile_image == "") {
      image = placeholderimg;
    } else {
      image = this.state.profile_image;
    }
    return (
      <Page title="View Profile" className="view-adminprofile">
        <ul className="cst-breadcrumb">
          <li>
            <Link to={"/dashboard"}>Home</Link>
          </li>
          <li> View Profile</li>
        </ul>
        <ReactTitle title="View Profile" />
        {/* 
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <Form name="viewadminprofile">
                  <FormGroup row>

                    <Col sm={7} className="profile-info ml-3" >

                      <div className="row form-group">
                        <label for="exampleEmail" className="col-4 col-form-label">First Name</label>
                        <label className="col-auto col-form-label">{this.state.firstname ? this.state.firstname : 'N/A'}</label>
                      </div>

                      <div className="row form-group">
                        <label for="exampleEmail" className="col-4 col-form-label">Last Name</label>
                        <label className="col-auto col-form-label">{this.state.lastname ? this.state.lastname : 'N/A'}</label>
                      </div>

                      <div className="row form-group">
                        <label for="exampleEmail" className="col-4 col-form-label">Email</label>
                        <label className="col-auto col-form-label"> {this.state.email}</label>
                      </div>

                      <div className="row form-group">
                        <label for="exampleEmail" className="col-4 col-form-label"> Contact Number</label>
                        <label className="col-auto col-form-label">{phone ? phone : 'N/A'}</label>
                      </div>

                      <div className="row form-group">
                        <label for="exampleEmail" className="col-4 col-form-label">Address</label>
                        <label className="col-auto col-form-label"> {this.state.address1 ? this.state.address1 : 'N/A'}</label>
                      </div>

                      <div className="row form-group">
                        <label for="exampleEmail" className="col-4 col-form-label">City</label>
                        <label className="col-auto col-form-label">{this.state.city ? this.state.city : 'N/A'}</label>
                      </div>


                      <div className="row form-group">
                        <label for="exampleEmail" className="col-4 col-form-label">State</label>
                        <label className="col-auto col-form-label"> {this.state.state ? this.state.state : 'N/A'}</label>
                      </div>

                     

                      <div className="row form-group">
                        <label for="exampleEmail" className="col-4 col-form-label">Zip Code</label>
                        <label className="col-auto col-form-label"> {this.state.zipcode ? this.state.zipcode : 'N/A'}</label>
                      </div>


                    </Col>
                    <Col className="col-3">
                      <figure className="view-profile-img" ><img src={image} /></figure>
                    </Col>

                  </FormGroup>
                </Form>
              </CardBody>

            </Card>
          </Col>
        </Row> */}

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="pt-0">
              <CardHeader>
                <Label for="examplePassword" sm={12} className="px-0">
                  <strong>
                    <MdInfoOutline fontSize="24" className="mr-2" />
                    Profile Info
                  </strong>
                </Label>
              </CardHeader>
              <CardBody>
                <Form name="viewadminprofile">
                  <FormGroup row>
                    <Col className="col-2 view-profile">
                      <figure className="view-profile-img">
                        <img src={image} />
                      </figure>
                    </Col>

                    <Col sm={7} className="profile-info ml-3">
                      <div className="row form-group">
                        <h2 className="cst-pfname mb-0">
                          {this.state.firstname ? this.state.firstname : "N/A"}{" "}
                          {this.state.lastname ? this.state.lastname : "N/A"}
                        </h2>
                      </div>

                      <div className="row form-group">
                        <label
                          htmlFor="exampleEmail"
                          className="col-4 col-form-label"
                        >
                          Email
                        </label>
                        <label className="col-auto col-form-label">
                          {" "}
                          {this.state.email}
                        </label>
                      </div>

                      <div className="row form-group">
                        <label
                          htmlFor="exampleEmail"
                          className="col-4 col-form-label"
                        >
                          {" "}
                          Contact Number
                        </label>
                        <label className="col-auto col-form-label">
                          {phone ? phone : "N/A"}
                        </label>
                      </div>

                      <div className="row form-group">
                        <label
                          htmlFor="exampleEmail"
                          className="col-4 col-form-label"
                        >
                          Address
                        </label>
                        <label className="col-auto col-form-label">
                          {" "}
                          {this.state.address1 ? this.state.address1 : "N/A"}
                        </label>
                      </div>

                      <div className="row form-group">
                        <label
                          htmlFor="exampleEmail"
                          className="col-4 col-form-label"
                        >
                          City
                        </label>
                        <label className="col-auto col-form-label">
                          {this.state.city ? this.state.city : "N/A"}
                        </label>
                      </div>

                      <div className="row form-group">
                        <label
                          htmlFor="exampleEmail"
                          className="col-4 col-form-label"
                        >
                          State
                        </label>
                        <label className="col-auto col-form-label">
                          {" "}
                          {this.state.state ? this.state.state : "N/A"}
                        </label>
                      </div>

                      <div className="row form-group">
                        <label
                          htmlFor="exampleEmail"
                          className="col-4 col-form-label"
                        >
                          Zip Code
                        </label>
                        <label className="col-auto col-form-label">
                          {" "}
                          {this.state.zipcode ? this.state.zipcode : "N/A"}
                        </label>
                      </div>
                    </Col>
                  </FormGroup>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
    );
  }
}

ViewadminProfile.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

//export default ChangepasswordPage;
export default connect(mapStateToProps, {})(ViewadminProfile);
